import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "crown",
  "use": "crown-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"crown\">\n    <g>\n        <path d=\"M13.424 2.595l-3.18 2.884a.3.3 0 0 1-.476-.102L7.507.24a.4.4 0 0 0-.729-.008L4.37 5.392a.3.3 0 0 1-.472.097L.667 2.592a.4.4 0 0 0-.66.37l1.326 7.18a1.2 1.2 0 0 0 1.18.982h9.104a1.2 1.2 0 0 0 1.181-.988l1.288-7.174a.4.4 0 0 0-.662-.367z\" />\n        <rect width=\"11\" height=\"1.5\" x=\"1.5\" y=\"13.559\" rx=\".6\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol